import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { ClipboardList } from 'lucide-react';
import ScriptViewer from '../components/leadDetail/ScriptViewer.jsx';
import { useLead } from '../hooks/useLead.js';
import { fmtPhone } from '../lib/format.js';

/**
 * Distraction-free call-script window (opened from the Call Scripts tab).
 * Lives outside the app layout so it can sit beside the dialer.
 * @returns {JSX.Element}
 */
export default function ScriptsPopout() {
  const [params] = useSearchParams();
  const leadId = params.get('leadId');
  const { lead } = useLead(leadId, { refetchInterval: 0 });
  const name = [lead?.firstName, lead?.lastName].filter(Boolean).join(' ');

  return (
    <div className="min-h-screen bg-civix-bg text-white">
      <header className="sticky top-0 z-10 flex items-center gap-2 px-4 py-3 bg-civix-purple">
        <ClipboardList className="w-4 h-4" />
        <div className="min-w-0">
          <div className="font-display font-bold truncate">{name ? `Scripts · ${name}` : 'Call Scripts'}</div>
          {lead?.phone && <div className="text-[11px] text-white/80">{fmtPhone(lead.phone)}</div>}
        </div>
      </header>
      <main className="p-4">
        <ScriptViewer lead={lead} large />
      </main>
    </div>
  );
}
